<div *ngIf="type === 'simple'" class="col-12 md-12 d-flex flex-column justify-content-center align-items-center">
    <p-button (onClick)="redirectPage(nextPageURL)">
        <i class="pi pi-circle-fill custom-circle-fill-icon"></i>
        <span class="px-4">{{ customTitle }}</span>
        <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
    </p-button>
</div>

<!-- Tipo completo con barra de progreso y botones de navegación -->
<!-- Barra de progreso superior -->
<div class="col-12" *ngIf="type === 'complete'">
    <p-progressBar
        [value]="value"
        [style]="{ height: '7px' }"
        class="progress-bar-custom"
    ></p-progressBar>
</div>

<!-- Botones de navegación -->
<div *ngIf="type === 'complete'" class="col-12 custom-page-navigation-bar">
    <div class="navigation-buttons">
        <!-- Regresar -->
        <button pButton pRipple class="p-button-info" (click)="onBackClick()">
            <span class="px-4">Regresar</span>
        </button>

        <!-- Guardar y salir -->
        <button *ngIf="showSaveExit" pButton pRipple class="p-button-info" (click)="onSaveClick()">
            <span class="px-4">Guardar y salir</span>
        </button>

        <!-- Siguiente -->
        <button pButton pRipple [loading]="loading" (click)="onNextClick()">
            <span class="px-4">Siguiente</span>
            <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
        </button>
    </div>
</div>
